module.exports = __webpack_public_path__ + "static/media/cancel2.ed77ad88.svg";